import type { OneOffChannel } from 'fym-shared/src/music24/oneOffPublish';

/**
 * The manual marks that a Kit slot offers in its footer (design assets-rethink b1, b3): "I added it"
 * for the Spotify Canvas and the Apple Music motion artwork, "I set it" for a profile banner of one
 * site, the Spotify header and the YouTube thumbnail. Instagram (a long video) is a manual mark too, but its slot offers
 * "Publish", like YouTube and Facebook.
 */
export const MANUAL_SET_CHANNELS: ReadonlyArray<OneOffChannel> = [
  'spotifyCanvas',
  'appleMusic',
  'youtubeBanner',
  'xBanner',
  'facebookBanner',
  'spotifyHeader',
  'youtubeThumbnail',
];
